import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { compose } from 'recompose';

import {
  Table as OriginalTable,
} from 'reactstrap';

const Table = ({
  children,
  isEmpty,
  emptyMessage,
  t,
  responsive,
  size,
}) => (
  <>
    { isEmpty && (
      <p style={{ marginTop: 20 }}>{emptyMessage || t('no.data.yet')}</p>
    )}
    {
      !isEmpty && (
        <OriginalTable hover responsive={responsive} size={size}>{ children }</OriginalTable>
      )
    }
  </>
);

Table.propTypes = {
  t: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  isEmpty: PropTypes.bool,
  emptyMessage: PropTypes.string,
  size: PropTypes.string,
  responsive: PropTypes.string,
};

Table.defaultProps = {
  emptyMessage: null,
  isEmpty: false,
  responsive: 'sm',
  size: 'sm',
};

export default compose(
  withTranslation(),
)(Table);
